import { Head } from '@inertiajs/react'

import { SetupForm } from '@/components/organizations/setup-form'
import { DashboardShell } from '@/layouts/dashboard-shell'
import type { OrganizationsConfigurationShow } from '@/types'

export default function OrganizationConfigurationShow({
  organization,
  repositories,
  availableRepositories,
  digestFrequency,
  timezone,
  digestHour,
  emailDigestEnabled,
  slackNotificationHour,
  weeklyLeaderboardEnabled,
  weeklyLeaderboardHour,
  isSlackConnected,
  githubError,
  title,
  description,
  submitLabel,
  formAction,
}: OrganizationsConfigurationShow) {
  return (
    <>
      <Head title={`${organization.name} — ${title}`} />
      <DashboardShell organization={organization} repositories={repositories} title={title}>
        <div className="mx-auto w-full max-w-2xl">
          {description ? (
            <p className="text-muted-foreground -mt-4 mb-6 text-sm">{description}</p>
          ) : null}
          <SetupForm
            action={formAction}
            submitLabel={submitLabel}
            selectedFullNames={repositories.map((repo) => repo.fullName)}
            availableRepositories={availableRepositories}
            digestFrequency={digestFrequency}
            timezone={timezone}
            digestHour={digestHour}
            emailDigestEnabled={emailDigestEnabled}
            slackNotificationHour={slackNotificationHour}
            weeklyLeaderboardEnabled={weeklyLeaderboardEnabled}
            weeklyLeaderboardHour={weeklyLeaderboardHour}
            isSlackConnected={isSlackConnected}
            githubError={githubError}
          />
        </div>
      </DashboardShell>
    </>
  )
}
